// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function fetchEmployerHistory({ options }, props, toCSV = false) {
  return { type: types.EMPLOYER_EVENTS_FETCH_BEGIN, options, toCSV }
}
